import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { FaTiktok, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <img 
                src="/logo.png" 
                alt="MMI Online - AI Automation Agency" 
                className="h-10 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 mb-4 max-w-md">
              Leverage the power of AI to pull in multiple £1000s in extra sales without asking you to do any extra work. Transform your business with intelligent automation.
            </p>
            <div className="flex space-x-4">
              <a href="mailto:contact@mmionline.online" className="text-gray-400 hover:text-primary-400 transition-colors" title="Email Us">
                <Mail className="w-5 h-5" />
              </a>
              <a href="tel:07427860249" className="text-gray-400 hover:text-primary-400 transition-colors" title="Call our Voice AI bot">
                <Phone className="w-5 h-5" />
              </a>
              <a href="https://www.tiktok.com/@mmi.online" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition-colors" title="TikTok">
                <FaTiktok className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/mmi.online_/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition-colors" title="Instagram">
                <FaInstagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-display font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/home" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-primary-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Solutions
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Database Reactivation</li>
              <li>Speed To Lead</li>
              <li>Out Of Hours Support</li>
              <li>Google Reviews AI</li>
              <li>Voice AI</li>
              <li>AI Advertisements</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} MMI Online. All Rights Reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-400 hover:text-primary-400 text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-primary-400 text-sm transition-colors">
              Terms of Service
            </Link>
            <Link to="/pricing-policy" className="text-gray-400 hover:text-primary-400 text-sm transition-colors">
              Pricing Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
